module.exports = __webpack_public_path__ + "static/media/sta_rosa.7ae5bab1.png";